import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ChatService } from './chatService';
import { ChatKey } from './keys';

export function useDeleteChat() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => ChatService.deleteChat(id).then((response) => response.data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [ChatKey.CHAT_LAST_CONVERSATIONS_INFINITE],
        exact: false,
      });
    },
  });
}
